import React, { Component } from 'react'
import Axios from 'axios';

import './TodoList.css';

import AddTodo from './AddTodo';
import TodoItem from './TodoItem';


class Todolist extends Component {
    //constructor(){ super() this.state = {}}   //or
    state = {
        todos: [
            // {
            // text: "Buy Milk",
            // completed: false
            // },
            // {
            // text: "Buy Egg",
            // completed: false
            // }
        ]
    };

    componentDidMount() {
      Axios.get("http://localhost:8080/todos")
      .then(result => {
          console.log(result);

          this.setState({
              todos: result.data
          });
      });
    };

    toggleComplete = (index) => {
      // const todo = this.state.todo[index];    or
      const { todos } = this.state;
      const todo = todos[index];

      const newTodos = this.state.todos
      .map((todo, i) => {
        if (index === i) {
          return {
            ...todo,
            completed: !todo.completed
          };
        }
        return todo;
        //return as it is, if not add return it show undefined / no output
      });

      // Axios.put("API header" + "add data with url", {}<- empty array will remove data from server/ {...todo, completed} <- update the value inside the list on server)
      Axios.put("http://localhost:8080/todos/" + todo.id, {
            ...todo,
            completed: !todo.completed
        })
        .then(() => {
            this.setState({
                todos: newTodos
            });
        });

      this.setState({
        todos: newTodos
      });
    };

    addTodoState = (text) => {
      Axios.post("http://localhost:8080/todos", {
            text,
            completed: false
        })
        .then((result) => {
          const newTodos = this.state.todos.concat({
            //as key & value both r same we write only text here as per ES6 rules
            // text: text
            text
          });

        //this will add new values inside todos list
        this.setState({
          todos: newTodos
        });
      });
    };

    deleteTodoFromState = (index) => {
      const { todos } = this.state;
      const todo = todos[index];

      Axios.delete("http://localhost:8080/todos/" + todo.id)
      .then(() => {
        const newTodos = this.state.todos
        .filter((todo, i) => {
        //   if (index === i) {
        //     return false;
        //   }
        //   return true;

        // or in small way
        return index === i ? false : true;
        });

        //this will remove selected item from todos list
        this.setState({
          todos: newTodos
        });
      });
    };

    editTodoState = (index, newText) => {
      const { todos } = this.state;
      const todo = todos[index];
      
      Axios.put("http://localhost:8080/todos/" + todo.id, {
          ...todo,
          text: newText
      })
      .then(() => {
      const newTodos = this.state.todos
      .map((todo, i) => {
        if (index === i){
          return {
              ...todo,
              text: newText
            };
          }
          return  todo;
        });

        // console.log(newTodos);
        this.setState({
          todos: newTodos
        });
      });
    };

  render() {
    return (
      <>
        <h2><i className="tasks icon"></i> Todo List </h2>
        <section>
            <AddTodo addTodoState={this.addTodoState} />
        </section>
        <section>
            {this.state.todos.map((todo, index) => {
                return (
                  <div key={index} className="ui middle aligned animated selection list">
                    <TodoItem 
                    todo={todo} 
                    key={index}
                    // can't access "key" react pacific inside "TodoItem" thrfor to access index we'll wrt this way, so that we can use index inside this component
                    index={index}
                    toggleComplete={this.toggleComplete}
                    deleteTodoFromState={this.deleteTodoFromState}
                    editTodoState={this.editTodoState}
                    />
                    <hr/>
                  </div>
                );
             })
            }
        </section>
      </>
    )
  }
}

export default Todolist;

// if we want to add any item inside the todo list, that can only be done by state in TodoList.js